const DOCS_BASE_URL = 'https://github.com/RainerTekOrg/pingr-notify#documentation';

/** Agents docs landing page. */
export const AGENTS_DOCS_HOME_URL = `${DOCS_BASE_URL}/agents`;

/** Introductory overview — replaces legacy `/agents/overview`. */
export const AGENTS_DOCS_OVERVIEW_URL = `${DOCS_BASE_URL}/agents/get-started/what-is-aci`;

/** How agents connect to Slack, Teams, email, and other providers. */
export const AGENTS_DOCS_PROVIDERS_URL = `${DOCS_BASE_URL}/agents/get-started/agents-and-providers`;

/** Conversations monitoring and cross-provider threads. */
export const AGENTS_DOCS_CONVERSATIONS_URL = `${DOCS_BASE_URL}/agents/conversations`;

/** Production setup checklist (bridge URL, integrations, inbound email). */
export const AGENTS_DOCS_SETUP_URL = `${DOCS_BASE_URL}/agents/custom-code-agent/setup-your-agent/overview`;
